import React, {useState} from 'react'
import {downLoadAttachment} from 'actions/applicants'
import {Typography} from '@material-ui/core'
import Button from 'components/shared/Button'
import Drawer from 'components/shared/Drawer';
import strings from 'strings'
import AuthService from "../../../../../../../tools/AuthService";
import VerificationReport from "../../../Verification/VerificationReport/VerificationReport";

const VerificationDrawer = (props) => {

    const { open, onClose, applicationId, data, savedReport = true, handleSave} = props
    const reportData = data?.response?.BIID20ResponseEx?.response?.Result
    const [loading, setLoading] = useState({list: false, report: false, save: false, download: false, attach: false});

    const { isReadOnlyUser } = AuthService.getClientFeatures()

    const handleDownload = () => {
        setLoading(prev => ({...prev, download: true}))
        downLoadAttachment(applicationId, data.pdfReportUuid, 'verification-report.pdf')()
            .finally(() => setLoading(prev => ({...prev, download: false})))
    }

    function getActions() {

        if (savedReport && !data?.pdfReportUuid) {
            return <Typography variant='body2' color='textSecondary'>Lexis sent no PDF for this report</Typography>
        }
        return (<div>
            {savedReport ?
                <div>
                    <Button variant='outlined' loading={loading.download} onClick={() => handleDownload()}>
                        {strings.DOWNLOAD_REPORT}
                    </Button>
                </div> :
                <Button loading={loading.save} onClick={handleSave} disabled={isReadOnlyUser}>{strings.Save}</Button>}
        </div>)
    }

    return (
        <Drawer
            open={open}
            title='Verification Report'
            onClose={onClose}
            actions={getActions()}
        >
            {open && <VerificationReport result={reportData} />}
        </Drawer>
    )
}

export default VerificationDrawer
